import {hasPermission} from '../../helpers'
import {useGetUser} from '../../store/userStore'
import {Dropdown} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import {ROUTES_POLICYTOOLS_SETTINGS, IPolicytoolsRouteInfo} from './routesPolicytoolsSettings'

export const NavPolicytoolsSettingMobile = () => {
  const permissions = useGetUser((s) => s.user?.permissions) || []
  const userGroups = useGetUser((s) => s.user?.groups)?.map((g: any) => g.name || g) || []

  const isRouteVisible = (r: IPolicytoolsRouteInfo) => {
    const hasPerm = r.perm ? hasPermission(permissions, r.perm) : false
    const hasGroup = r.group ? userGroups.includes(r.group) : false
    const gated = Boolean(r.perm) || Boolean(r.group)
    return gated ? hasPerm || hasGroup : true
  }

  const VISIBLE = ROUTES_POLICYTOOLS_SETTINGS.filter(isRouteVisible)

  if (VISIBLE.length === 0) {
    return null
  }

  return (
    <Dropdown drop='up'>
      <Dropdown.Toggle size='sm' variant='secondary' id='dropdown-policytools-settings' className='w-100'>
        Policytools Settings
      </Dropdown.Toggle>

      <Dropdown.Menu className='w-100 drop-scrollbar'>
        {VISIBLE.map((info) => (
          <Dropdown.Item key={info.id} as={Link} to={info.route} style={{color: '#133159'}}>
            {info.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}
